import React from 'react'
import BudgetsRequests from 'src/app/BudgetsRequests/BudgetsRequests'
import { AppLocation, SidenavContentType } from 'src/navigation/appLocations'
import { AppRoute } from 'src/navigation/appRoutes'
import { myWalletBudgetsPendingRouteProps } from 'src/navigation/routeProps'

const MyWalletBudgetsPendingAppRoute: AppRoute = {
  id: AppLocation.MyWalletBudgetsPending,
  routeProps: myWalletBudgetsPendingRouteProps,
  component: <BudgetsRequests />,
  subRoutes: [],
  meta: { contentType: SidenavContentType.Main },
}

export default MyWalletBudgetsPendingAppRoute
